<template>
  <div id="Mahasiswa">
      <div class="r-option-place r-center-flex" style="flex-wrap : wrap;">
        <div class="y-inputField"  style="margin-right: auto;">
            <div class="y-hasIcon-right y-md-size">
                <input type="text" v-model="request.search" @keyup="setTime()" @keydown="clearTime()" @keydown.tab="setTime()" @keyup.tab="clearTime()" @keypress.enter="getData()" placeholder="Search . . .">
                <div class="y-inputIcon r-center-flex">
                    <img :src="require('@/assets/icons/others/search.svg')" alt="">
                </div>
            </div>
        </div>
        <button class="y-primary-btn y-md-size is-fullonmobile " @click.prevent="openModal()">
            Tambah Kategori
        </button>
      </div>
      <div class="r-table">
          <table>
            <caption>
              <div class="y-inputField" style="margin-right: auto;">
                  <div class="y-hasIcon-right y-md-size">
                      <input type="text" v-model="dataLabel[request.sortBy]" readonly @click="showThead = !showThead" placeholder="Urut Berdasarkan">
                  </div>
              </div>
            </caption>
            <thead>
                <tr class="hideThead" :class="showThead ? 'showThead' : ''">
                    <th class="r-table-firstColumn">No</th>
                    <th> <div class="r-center-flex" @click.prevent="showThead = !showThead;setSortBy('created_at')" :class="request.sortBy == 'created_at' ? 'y-darkBlue-text' : ''" style="cursor:pointer;"> <span style="margin-right: auto">Tanggal Pembuatan</span> <img :style="request.sortBy == 'created_at' && request.sorting == 'ASC' ? 'transform: rotate(180deg)' : ''" :src="require(`@/assets/icons/others/sortBy-arrow-${request.sortBy == 'created_at' ? 'blue' : 'gray'}.svg`)"> </div></th>
                    <th> <div class="r-center-flex" @click.prevent="showThead = !showThead;setSortBy('name')" :class="request.sortBy == 'name' ? 'y-darkBlue-text' : ''" style="cursor:pointer;"> <span style="margin-right: auto">Nama </span> <img :style="request.sortBy == 'name' && request.sorting == 'ASC' ? 'transform: rotate(180deg)' : ''" :src="require(`@/assets/icons/others/sortBy-arrow-${request.sortBy == 'name' ? 'blue' : 'gray'}.svg`)"> </div></th>
                    <th> <div class="r-center-flex" @click.prevent="showThead = !showThead;setSortBy('weight')" :class="request.sortBy == 'weight' ? 'y-darkBlue-text' : ''" style="cursor:pointer;"> <span style="margin-right: auto">Bobot </span> <img :style="request.sortBy == 'weight' && request.sorting == 'ASC' ? 'transform: rotate(180deg)' : ''" :src="require(`@/assets/icons/others/sortBy-arrow-${request.sortBy == 'weight' ? 'blue' : 'gray'}.svg`)"> </div></th>
                    <th> <div class="r-center-flex" @click.prevent="showThead = !showThead;setSortBy('type')" :class="request.sortBy == 'type' ? 'y-darkBlue-text' : ''" style="cursor:pointer;"> <span style="margin-right: auto">Tipe </span> <img :style="request.sortBy == 'type' && request.sorting == 'ASC' ? 'transform: rotate(180deg)' : ''" :src="require(`@/assets/icons/others/sortBy-arrow-${request.sortBy == 'type' ? 'blue' : 'gray'}.svg`)"> </div></th>
                    <th> <div class="r-center-flex" @click.prevent="showThead = !showThead;setSortBy('exam_type_id')" :class="request.sortBy == 'exam_type_id' ? 'y-darkBlue-text' : ''" style="cursor:pointer;"> <span style="margin-right: auto">Ujian </span> <img :style="request.sortBy == 'exam_type_id' && request.sorting == 'ASC' ? 'transform: rotate(180deg)' : ''" :src="require(`@/assets/icons/others/sortBy-arrow-${request.sortBy == 'exam_type_id' ? 'blue' : 'gray'}.svg`)"> </div></th>
                    <th> <div class="r-center-flex" @click.prevent="showThead = !showThead;setSortBy('status')" :class="request.sortBy == 'status' ? 'y-darkBlue-text' : ''" style="cursor:pointer;"> <span style="margin-right: auto">Status </span> <img :style="request.sortBy == 'status' && request.sorting == 'ASC' ? 'transform: rotate(180deg)' : ''" :src="require(`@/assets/icons/others/sortBy-arrow-${request.sortBy == 'status' ? 'blue' : 'gray'}.svg`)"> </div></th>
                    <th class="r-table-actionColumn">Action</th>
                </tr>
            </thead>
            <loading v-if="fetchData"/>
            <nodata v-if="resultData.length == 0"></nodata>
              <tr v-for="(item, index) in resultData" :key="`${item.id}-rubric`" @click.prevent="popup = curNumber(index)">
                  <td data-label="No" class="r-table-firstColumn" >{{curNumber(index)}}</td>
                  <td data-label="Tanggal Pembuatan" >{{convertDateTime(item.created_at)}}</td>
                  <td data-label="Nama" >{{item.name}}</td>
                  <td data-label="Bobot" >{{item.weight}} </td>
                  <td data-label="Tipe" >{{item.type}} </td>
                  <td data-label="Ujian" >{{item.exam_type}} </td>
                  <td data-label="status" >
                        <button class="y-sm-size" :class="item.status == 1 ? 'y-success-btn' : 'y-danger-btn '" @click.prevent.stop="updateStatus(item.id)">
                            <img :src="require('@/assets/loadingDot.svg')" alt style="width: 50px;" v-if="statusLoading == item.id" />   
                            <span v-else> {{item.status == 1 ? 'Aktif' : 'Tidak Aktif'}} </span>
                        </button>
                  </td>
                  <td data-label="Action" class="r-table-actionColumn">
                      <div class="r-menu">
                          <img class="r-is-clickable" :src="require('@/assets/icons/others/more.svg')" @click.prevent="popup = curNumber(index)">
                          <div class="r-menu-items" v-if="popup == curNumber(index)" @mouseleave="popup = -1">
                                <router-link class="r-menu-item y-black-text r-center-flex" :to="{name: 'PptaRubricField', params: {categoryId: item.id}}" >
                                    Daftar Aspek Penilaian
                                </router-link>
                                <div class="r-menu-item y-black-text r-center-flex" @click.prevent="openModal(item,'Ubah')" >Ubah Data</div>
                                <div class="r-menu-item y-red-text r-center-flex"  @click.prevent="confirmDelete(item)" >Hapus</div>
                          </div>
                      </div>
                    </td>
              </tr>
          </table>
          <div class="r-table-pagination">
              <div class="r-pagination r-center-flex r-isWrap">
                <div class="r-mr-auto r-center-flex r-mt-10">
                    <span>Data per halaman: </span> 
                    <div class="r-autocomplete2"  @click.prevent="pageDropdown = !pageDropdown">
                        <p class="r-inputStyle r-ptb-4 r-plr-12 r-mlr-10">{{request.show}}</p>
                        <div class="r-autocomplete2-place" v-if="pageDropdown" @mouseleave="pageDropdown = false">
                            <div class="r-autocomplete2-items">
                                    <div class="r-autocomplete2-item" @click.prevent="setShow(10)" >10</div>
                                    <div class="r-autocomplete2-item" @click.prevent="setShow(25)" >25</div>
                                    <div class="r-autocomplete2-item" @click.prevent="setShow(50)" >50</div>
                                    <div class="r-autocomplete2-item" @click.prevent="setShow(100)" >100</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="r-ml-auto r-center-flex r-mt-10">
                    <span>{{data.from == null ? 0 : data.from}} - {{data.to == null ? 0 : data.to}} dari {{data.total == null ? 0 : data.total}}</span>
                    <div class="r-pagination-movebutton r-center-flex">
                        <input type="image" :src="require('@/assets/icons/others/arrow-left.svg')" :disabled="request.page < 2" @click.prevent="getData(-1)">
                        <input type="image" style="transform: rotate(180deg)" :src="require('@/assets/icons/others/arrow-left.svg')" :disabled="request.page >= data.last_page" @click.prevent="getData(1)">
                    </div>
                </div>
              </div>
          </div>
      </div>
      <!-- modal for add and edit-->
       <div class="r-modal" v-if="modal == 'submit'">
            <div class="r-box"> 
                <div class="r-header">
                    <h1>{{InputType}} Kategori</h1>
                </div>
                <div class="r-body">
                    <div class="y-inputField">
                        <div class="y-labelText">
                            Nama
                        </div>
                        <div class="y-hasIcon-right y-lr-size">
                            <input type="text" v-model="item.name" :class="error.name ? 'y-red-outline' : ''" placeholder="">
                        </div>
                        <div class="y-errorText y-red-text" :style="error.name ? 'opacity: 1 !important;': ''">
                            {{errorMsg.name}}
                        </div>
                    </div>
                    <div class="y-inputField">
                        <div class="y-labelText">
                            Bobot
                        </div>
                        <div class="y-hasIcon-right y-lr-size">
                            <input type="number" v-model="item.weight" :class="error.weight ? 'y-red-outline' : ''" placeholder="Contoh: 50">
                        </div>
                        <div class="y-errorText y-red-text" :style="error.weight ? 'opacity: 1 !important;': ''">
                            {{errorMsg.weight}}
                        </div>
                    </div>

                    <div class="y-inputField">
                        <div class="y-labelText">
                            Ujian
                        </div>
                        <div class="y-inputPlace y-hasIcon-right">
                            <div class="y-select-hasIcon" style="width: 100%">
                                <select class="y-select" v-model="item.exam_type_id">
                                    <option class="y-option" :value="e.id" v-for="(e,i) in examTypes" :key="`examtype-${i}`">{{e.name}}</option>
                                </select>
                                <div class="y-select-icon">
                                    <img :src="require('@/assets/icons/others/arrowDown.svg')" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="y-inputField">
                        <div class="y-labelText">
                            Tipe
                        </div>
                        <div class="y-inputPlace y-hasIcon-right">
                            <div class="y-select-hasIcon" style="width: 100%">
                                <select class="y-select" v-model="item.type">
                                    <option class="y-option" value="Penguji">Dosen Penguji</option>
                                    <option class="y-option" value="Pembimbing">Dosen Pembimbing</option>
                                </select>
                                <div class="y-select-icon">
                                    <img :src="require('@/assets/icons/others/arrowDown.svg')" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="r-footer">
                    <div class="r-center-flex" style="padding: 10px 0px;">
                        <button class="y-secondary-btn y-hasspace-btn y-sm-size" style="margin-left: auto;" @click.prevent="resetData()">
                            Batal
                        </button>
                        <button class="y-primary-btn y-hasspace-btn y-sm-size" @click.prevent="sendData()">
                            <span v-if="!loading">Kirim</span>
                            <img :src="require('@/assets/loadingDot.svg')" alt style="width: 50px;" v-else />   
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- modal for add and edit -->
      <!-- modal for Delete-->
       <div class="r-modal" v-if="modal == 'delete'">
            <div class="r-box"> 
                <div class="r-header">
                    <h1>Hapus Kategori</h1>
                </div>
                <div class="r-body r-info-warning">
                    Apakah anda yakin untuk menghapus kategori dengan nama "{{item.name}}" ? 
                </div>
                <div class="r-footer">
                    <div class="r-center-flex" style="justify-content: center; padding: 10px 0px;">
                        <button class="y-secondary-btn y-hasspace-btn y-sm-size"  @click.prevent="resetData()">
                            Batal
                        </button>
                        <button class="y-danger-btn y-hasspace-btn y-sm-size" @click.prevent="destroyData(item.id)">
                            <span v-if="!loading">Hapus</span>
                            <img :src="require('@/assets/loadingDot.svg')" alt style="width: 50px;" v-else />   
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- modal for add and edit -->
  </div>
</template>
<script>
import {
    convertDateTime
} from '@/common/timeformat'
import { mapGetters, mapActions } from 'vuex'
import { thesisName } from '@/common/helper';
const itemInit = {
    id: '',
    name: '',
    weight: '',
    type: '',
    exam_type_id: null
}
export default {
    components:{
    'loading' : () => import( /* webpackChunkName: "loading" */ `@/components/common/loading.vue`),
    'nodata' : () => import( /* webpackChunkName: "nodata" */ `@/components/common/nodata.vue`)
  },
  mounted() {
    this.initData()
  },
  computed:{
    ...mapGetters({
    }),
    resultData(){
        return this.data.data
    }
  },
  data: () => ({
    moduleName: 'pptaRubric',
    statusLoading: null,
    dataLabel:{
        created_at: 'Tanggal Pembuatan',
        name: 'Nama',
        weight: 'Bobot',
        type: 'Tipe',
        status: 'Status',
    },
    showThead: false,
    error: {
        weight: false,
        type : false,
        exam_type_id : false,
        name: false
    },
    errorMsg: {
        weight: 'Bobot tidak boleh kosong',
        name: 'Nama tidak boleh kosong',
        exam_type_id: 'Nama tidak boleh kosong',
        type : 'Tipe tidak boleh kosong'
    },
    modal: false,
    popupdetail: false,
    item: itemInit,
    InputType: 'Tambah',
    popup: -1,
    request:{
        page: 1,
        show: 10,
        sortBy: "created_at",
        sorting: "DESC",
        search: null
    },
    pageDropdown: false,
    fetchData: false,
    loading: false,
    data: {
        last_page: 0,
        data: [],
        total: 0,
    },
    nameSpace: 'ppta-category'
  }),
  methods:{
    ...mapActions({
      getExamType: 'examtype/fetchData'
    }),
    thesisName(){
        return thesisName()
    },
    async initData(){
      await this.getExamType()
      this.getData();
      this.setBreadCrumb()
    },
    setBreadCrumb(){
        var breadcrumb = [{
                name: `Kategori Rubrik PPTA`,
                link: {},
                current: true
            }
        ]
        this.$store.commit("SET_ACTIVETAB", 'PPTA');
        this.$store.commit("SET_BREADCRUMB", breadcrumb);
    },
    async updateStatus(id){
        this.statusLoading = id
        var url = this.nameSpace+'/'+id
        this.loading = true
        await this.$store.dispatch(`${this.moduleName}/updateStatus`,url)
        this.getResponse()
    },
    async destroyData(id){
        var url = this.nameSpace+'/'+id
        this.loading = true
        await this.$store.dispatch(`${this.moduleName}/destroy`,url)
        this.getResponse()
    },
    confirmDelete(data) {
        this.item = data
        this.modal = 'delete'
    },
    validate(){
      var error = 0
      var field = ['name','type','exam_type_id']
      for (var i = 0; i < field.length; i++){
        if(this.item[field[i]] === null || this.item[field[i]]  === ''){
          this.error[field[i]] = true
          error += 1;
        }else{
          this.error[field[i]] = false
        }
      }
      if(this.item.weight !== null && this.item.weight !== ""){
          if(!(/^\d+$/.test(this.item.weight))){
              this.error.weight = true
              this.errorMsg.weight = "Hanya boleh angka"
              error += 1;
          }else{
              this.error.weight = false
          }
      }else{
        this.error.weight = false
      }
      return error
    },
    async sendData(){
        if(this.validate() === 0){
            this.loading = true
            var url = this.nameSpace
            if(this.InputType != 'Tambah'){
                url += '/'+this.item.id
            }
            await this.$store.dispatch(`${this.moduleName}/submit`,{url: url,data: this.item})
            this.getResponse()
        }else{
            this.$store.dispatch("showSnackbar", {
                type: "error",
                text: "Mohon periksa kembali"
            })
        }
    },
    getResponse(){
        this.loading = false
        this.fetchData = false
        this.statusLoading = null
        var status = this.$store.getters[`${this.moduleName}/getStatus`]
        var msg = this.$store.getters[`${this.moduleName}/getMsg`]
        if(status === 1){
            this.$store.dispatch("showSnackbar", {
                type: "success",
                text: msg
            })
            this.resetData()
            this.getData()
        }else{
            this.$store.dispatch("showSnackbar", {
                type: "error",
                text: msg
            })
        }
    },
    openModal(data = itemInit, InputType = 'Tambah'){
        this.item = {
            id: data.id,
            name: data.name,
            weight: data.weight,
            type: data.type,
            exam_type_id: data.exam_type_id,
        }
        this.InputType = InputType
        this.modal = "submit"
    },  
    resetData(){
        this.item = itemInit
        this.modal = null
    },
    curNumber(index){
        return index + (this.request.show * (this.request.page - 1)) + 1
    },
    setTime() {
        this.fetchData = true
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.getData, 1000);
    },
    clearTime() {
        clearTimeout(this.typingTimer);
    },
    setSortBy(value){
        if(value == this.request.sortBy){
            if(this.request.sorting == 'DESC'){
                this.request.sorting = 'ASC'
            }else{
                this.request.sorting = 'DESC'
            }
        }else{
            this.request.sorting = 'DESC'
        }
        this.request.sortBy = value
        this.getData()
    },
    setShow(value){
        this.request.show = value
        this.getData()
    },
    async getData(type = 0) {
        this.fetchData = true
        if(type === 0){
            this.request = this.$store.getters[`${this.moduleName}/getRequest`]
            this.request.page = 1
        }else{
            this.request.page += type
        }
        this.data = this.$store.getters[`${this.moduleName}/getItem`]('category')
        await this.$store.dispatch(`${this.moduleName}/fetchData`, {request: this.request, url: this.nameSpace, type: 'category'})
        var status = this.$store.getters[`${this.moduleName}/getStatus`]
        var msg = this.$store.getters[`${this.moduleName}/getMsg`]
        this.fetchData = false
        if(status === 1){
            this.data = this.$store.getters[`${this.moduleName}/getItem`]('category')
        }else{
            this.$store.dispatch("showSnackbar", {
                type: "error",
                text: msg
            })
        }
    },
    order(sortBy){
        this.request.sortBy = sortBy
        if(this.request.sorting == "DESC"){
            this.request.sorting = "ASC"
        }else{
            this.request.sorting = "DESC"
        }
        this.getData()
    },
    convertDateTime(value){
        return convertDateTime(value);
    }
  }
};
</script>